import { render, staticRenderFns } from "./WebOrders.vue?vue&type=template&id=cdcd1dac&scoped=true&"
import script from "./WebOrders.vue?vue&type=script&lang=js&"
export * from "./WebOrders.vue?vue&type=script&lang=js&"
import style0 from "./WebOrders.vue?vue&type=style&index=0&id=cdcd1dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcd1dac",
  null
  
)

export default component.exports